module.exports = __webpack_public_path__ + "img/qrcode-download-app.d8ca3e2c.png";